var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{
        'text-success': _vm.value,
        'text-secondary': !_vm.value,
        'disabled': _vm.disabled
    },on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('i',{staticClass:"fa fa-lg icon-button",class:_vm.value ? 'fa-toggle-on' : 'fa-toggle-off',attrs:{"title":_vm.title}})])
}
var staticRenderFns = []

export { render, staticRenderFns }